import * as tdsConstants from '@/utils/constants'
import { tdsGrid } from '@/graph_parts/grid'
import { startEditingOnAnimationFinished, startEditingOnLayoutCompleted } from '@/graph_parts/editing_text'
import { finishDrop, adjustGroupContents, addPartsToGroupAtPosition } from '@/graph_parts/moving'
import { uuid } from '@/utils/uuid'
import { TdsCommandHandler } from '@/graph_parts/tds_command_handler'
import { emitterSingleton } from '@/graph_parts/emitter'
import { removeOperators, insertOperators } from '@/graph_parts/operators'
import { rightOfNode, getDiagramTopLeft } from '@/graph_parts/common_template_support'
import * as go from 'gojs'

var $ = go.GraphObject.make
let myEmitter = emitterSingleton.instance
let lastNewNodeOnTypingMousePosition = null
let lastNewNodeOnTypingPart = null

function determineOverviewVisibility (e) {
  const db = e.diagram.documentBounds
  const vb = e.diagram.viewportBounds
  const overviewDiv = document.getElementById(e.diagram.tdsOverviewDivId)
  if (vb.height > 1 &&
      (vb.width < db.width || vb.height < db.height)) {
    overviewDiv.style.display = 'inline'
    if (e.diagram.tdsOverview === null || overviewDiv.style.display === 'none') {
      e.diagram.tdsOverview = $(go.Overview, overviewDiv)
      e.diagram.tdsOverview.observed = e.diagram
    }
  } else {
    overviewDiv.style.display = 'none'
  }
}

function mpNotUseful (diagram) {
  return typeof diagram.tdsLastMousePosition === 'undefined' ||
      diagram.tdsLastMousePosition.equals(new go.Point(0, 0))
}

function calculatePosition (diagram) {
  const mousePosition = mpNotUseful(diagram)
    ? (() => {
      const tl = getDiagramTopLeft(diagram)
      return new go.Point(tl.x, tl.y - tdsConstants.offsetNodeAboveDiagram)
    })()
    : diagram.transformViewToDoc(diagram.tdsLastMousePosition)
  return mousePosition
}

function addNewNodeAndStartEdit (diagram, lastInputKey, clickObjectKey) {
  const initialCharacter = typeof lastInputKey === 'undefined' ? '' : lastInputKey
  const mousePosition = calculatePosition(diagram)
  let p = mousePosition
  // If not moved cursor since adding last node
  // or added one with no mouse position yet
  if (mousePosition.equals(lastNewNodeOnTypingMousePosition) ||
      (mpNotUseful(diagram) && lastNewNodeOnTypingPart !== null)) {
    const right = rightOfNode(lastNewNodeOnTypingPart)
    p = new go.Point(right.x, right.y)
  } else {
    lastNewNodeOnTypingMousePosition = mousePosition
  }
  lastNewNodeOnTypingPart = addNewNodeAndStartEditAtLocation(diagram, p, initialCharacter, clickObjectKey)
}

function addNewNodeAndStartEditAtLocation (diagram, point, initialCharacter, clickObjectKey) {
  const newNodeKey = uuid()
  const newNodeData = { key: newNodeKey, text: initialCharacter, ...tdsConstants.defaultNodeAttributes }
  let pointToUse = point
  let node
  diagram.startTransaction()
  if (clickObjectKey) {
    const clickObject = diagram.findNodeForKey(clickObjectKey)
    if (clickObject) {
      diagram.model.addNodeData(newNodeData)
      node = diagram.findNodeForData(newNodeData)
      const partsToAdd = new go.List()
      partsToAdd.add(node)
      addPartsToGroupAtPosition(diagram, calculatePosition(diagram), partsToAdd, clickObject)
    }
  } else {
    node = addNewPartAtLocation(diagram, newNodeData, pointToUse)
  }
  diagram.commitTransaction()
  if (node) {
    diagram.toolManager.textEditingTool.selectsTextOnActivate = false
    diagram.commandHandler.editTextBlock(node.elt(0).elt(1).elt(1).elt(1))
  }
  return node
}

function addNewPartAtLocation (diagram, newPartData, point) {
  diagram.startTransaction()
  diagram.model.addNodeData(newPartData)
  const node = diagram.findNodeForData(newPartData)
  node.position = point
  diagram.commitTransaction()
  return node
}

function createGroup (diagram, clickObjectKey) {
  const key = uuid()
  const newGroupData = {
    key: key,
    ...tdsConstants.defaultGroupAttributes,
    childrenPrefixOperatorVisible: diagram.tdsLayoutInline
  }
  if (diagram.tdsLayoutInline) {
    newGroupData.layout = 'horizontal'
  }
  let g
  if (clickObjectKey !== undefined) {
    const clickObject = diagram.findNodeForKey(clickObjectKey)
    if (clickObject) {
      diagram.model.addNodeData(newGroupData)
      g = diagram.findNodeForData(newGroupData)
      const partsToAdd = new go.List()
      partsToAdd.add(g)
      addPartsToGroupAtPosition(diagram, calculatePosition(diagram), partsToAdd, clickObject)
    }
  } else {
    g = addNewPartAtLocation(diagram, newGroupData, calculatePosition(diagram))
  }
  if (g) {
    removeOperators(g, diagram)
    if (diagram.tdsLayoutInline) {
      insertOperators(g, diagram, g.data.operator, g.part.data.key)
    }
  }
}

function handleMouseOver (e) {
  e.diagram.tdsLastMousePosition = e.viewPoint
}

function walkIsIncluded (model, newValue, obj) {
  model.setDataProperty(obj.data, 'isParentExcludedInQuery', newValue)
  if (obj.data.isGroup) {
    const i = obj.memberParts
    while (i.next()) {
      walkIsIncluded(model, newValue, i.value)
    }
  }
}

function toggleIsIncludedInQuery (parts, diagram, newValue) {
  diagram.startTransaction('toggleIsIncludedInQuery')
  if (parts && parts.length > 0) {
    parts.forEach(p => {
      diagram.model.setDataProperty(p.data, 'isIncludedInQuery', newValue)
      walkIsIncluded(diagram.model, !newValue, p)
    })
  }
  diagram.commitTransaction('toggleIsIncludedInQuery')
  myEmitter.emitter.bus.$emit('queryChanged')
}

function sortAZGroup (group, diagram) {
  const listToSort = []
  const it = group.memberParts
  while (it.next()) {
    const pd = it.value.data
    if (!pd.isOperator) {
      listToSort.push(pd)
    }
  }
  listToSort.sort((a, b) => {
    if ((a.isGroup && b.isGroup) ||
        (!a.isGroup && !a.isGroup)) {
      if (a.text && b.text) {
        return a.text.localeCompare(b.text)
      } else {
        return -1
      }
    } else {
      if (!a.isGroup) {
        return -1
      } else {
        return 1
      }
    }
  })
  let ordering = 10
  listToSort.forEach(pd => {
    diagram.model.setDataProperty(pd, 'ordering', ordering)
    ordering += 10
  })
  removeOperators(group, diagram)
  if (diagram.tdsLayoutInline) {
    insertOperators(group, diagram, group.data.operator, group.part.data.key)
  }
  group.invalidateLayout()
}
function sortAZ (parts, diagram) {
  diagram.startTransaction('sortaZ')
  if (parts && parts.length > 0) {
    parts.forEach(p => {
      sortAZGroup(p, diagram)
    })
  }
  diagram.layoutDiagram(true)
  diagram.commitTransaction('sortAZ')
  myEmitter.emitter.bus.$emit('queryChanged')
}

function TdsDraggingTool () {
  go.DraggingTool.call(this)
}
go.Diagram.inherit(TdsDraggingTool, go.DraggingTool)

function setOperatorIsBeingEdited (textBlock, isBeingEdited) {
  const i = textBlock.part.containingGroup.part.memberParts.iterator
  while (i.next()) {
    if (i.value.part.data.isOperator) {
      textBlock.diagram.model.setDataProperty(i.value.part.data, 'isBeingEdited', isBeingEdited)
    }
  }
}

function createDiagram (divId, overviewDivId, gridVisible) {
  const d = $(go.Diagram, divId,
    {
      allowDrop: true,
      'grid.visible': gridVisible,
      initialDocumentSpot: new go.Spot(0.05, 0, 0, 0),
      initialViewportSpot: new go.Spot(0.05, 0, 0, 0),
      commandHandler: $(TdsCommandHandler),
      'commandHandler.archetypeGroupData': tdsConstants.defaultGroupAttributes,
      'undoManager.isEnabled': true,
      'textEditingTool.starting': go.TextEditingTool.DoubleClick,
      'textEditingTool.selectsTextOnActivate': true,
      'textEditingTool.doActivate': function () {
        go.TextEditingTool.prototype.doActivate.call(this)
        if (this.textBlock.part.data.isOperator) {
          setOperatorIsBeingEdited(this.textBlock, true)
        }
      },
      'textEditingTool.doDeactivate': function () {
        if (this.textBlock.part.data.isOperator) {
          setOperatorIsBeingEdited(this.textBlock, false)
        }
        go.TextEditingTool.prototype.doDeactivate.call(this)
        this.selectsTextOnActivate = true
      },
      'draggingTool.gridSnapCellSpot': new go.Spot(0, 0, -45, -10),
      draggingTool: new TdsDraggingTool(),
      mouseDrop: finishDrop,
      mouseOver: handleMouseOver,
      'toolManager.hoverDelay': 200
    }
  )
  TdsDraggingTool.prototype.doActivate = function () {
    go.DraggingTool.prototype.doActivate.call(this)
    if (this.draggedParts && this.draggingParts.count > 0) {
      const x = this.draggedParts.first().key
      this.gridSnapCellSpot = x.data.isGroup
        ? new go.Spot(0, 0, -45, -10)
        : new go.Spot(0, 0, 0, -1)
    }
  }

  d.addDiagramListener('PartCreated', function (e) {
    if (!e.subject.data.isGroup) {
      e.diagram.addDiagramListener('LayoutCompleted', startEditingOnLayoutCompleted)
      e.diagram.tdsPartCreated = e.subject.findObject('TERM_TEXT_BLOCK')
    }
  })
  d.tdsOverviewDivId = overviewDivId
  d.tdsOverview = null
  d.addDiagramListener('DocumentBoundsChanged', determineOverviewVisibility)
  d.addDiagramListener('ViewportBoundsChanged', determineOverviewVisibility)
  d.addDiagramListener('SelectionDeleted', function (e) {
    e.diagram.model.startTransaction('SelectionDeleted')
    const x = e.subject.iterator
    while (x.next()) {
      const g = x.value.containingGroup
      if (g) {
        adjustGroupContents(e.diagram, g, x.value)
      }
      if (g) {
        g.layout.invalidateLayout()
      }
    }
    e.diagram.model.commitTransaction('SelectionDeleted')
    // e.diagram.layoutDiagram(true)
    // adjustGroupContentsFromSelection(e)
  })
  d.addDiagramListener('AnimationFinished', startEditingOnAnimationFinished)
  d.addDiagramListener('LayoutCompleted', startEditingOnLayoutCompleted)
  d.addDiagramListener('SelectionGrouped', function (e) {
    let ordering = 10
    e.subject.memberParts.each(function (m) {
      e.diagram.model.setDataProperty(m.data, '_count', null)
      e.diagram.model.setDataProperty(m.data, '_showingCount', null)
      e.diagram.model.setDataProperty(m.data, 'ordering', ordering)
      ordering += 10
    })
    e.diagram.model.setDataProperty(e.subject.data, 'text', tdsConstants.defaultGroupName)
    e.diagram.model.setDataProperty(e.subject.data, 'childrenPrefixOperatorVisible', e.diagram.tdsLayoutInline)
    e.diagram.model.setDataProperty(e.subject.data, 'gridLayout', e.diagram.tdsLayoutInline ? 'inline' : 'nested')
    removeOperators(e.subject, e.diagram)
    if (e.diagram.tdsLayoutInline) {
      insertOperators(e.subject, e.diagram, e.subject.data.operator, e.subject.part.data.key)
    }
  })
  d.addDiagramListener('ObjectContextClicked', function (e) {
    myEmitter.emitter.bus.$emit('showingContextMenu')
  })
  d.addDiagramListener('BackgroundContextClicked', function (e) {
    myEmitter.emitter.bus.$emit('showingContextMenu')
  })
  d.addDiagramListener('BackgroundDoubleClicked', function (e) {
    addNewNodeAndStartEdit(d)
  })

  if (gridVisible) {
    d.grid = tdsGrid()
  }

  d.div.style.height = 'calc(100vh - 75px)'

  d.commandHandler.doKeyDown = function () {
    const e = d.lastInput
    const cmd = d.commandHandler
    const k = e.event.key.charCodeAt(0)
    if ((e.modifiers === 0 || e.shift) && e.event.key.length === 1 && k >= 33 && k <= 126) { // ordinary printable character key
      addNewNodeAndStartEdit(d, e.event.key)
    } else {
      go.CommandHandler.prototype.doKeyDown.call(cmd)
    }
  }

  d.commandHandler.selectAll = function () {
    d.findTreeRoots().each(n => {
      n.isSelected = true
    })
  }

  const tool = d.toolManager.clickSelectingTool
  tool.standardMouseSelect = function () {
    if (d === null || !d.allowSelect) {
      return
    }
    const e = d.lastInput
    if (e && e.shift) {
      var part = d.findPartAt(e.documentPoint, false)
      if (part !== null) {
        const newValue = !part.data.isIncludedInQuery
        toggleIsIncludedInQuery([part], d, newValue)
        if (newValue === false) {
          d.model.setDataProperty(part.data, '_count', null)
          d.model.setDataProperty(part.data, '_showingCount', null)
        }
      }
    } else {
      go.ClickSelectingTool.prototype.standardMouseSelect.call(tool)
    }
  }

  return d
}

const excludedPropertyNames = [
  'mouseDrop', 'contextMenu', 'grid', 'nodeTemplateMap', 'fill', 'stroke',
  'spot1', 'spot2', 'position', 'location', 'layout', '_duplicated', 'fromSpot',
  'toSpot', 'mouseOver', 'nodeTemplate', 'linkTemplate', 'points'
]

function shouldUpdate (e) {
  const txn = e.object
  if (txn === null) return
  let isUpdated = false
  txn.changes.each((x) => {
    if ((x.change === go.ChangedEvent.Property ||
          x.change === go.ChangedEvent.Insert ||
          x.change === go.ChangedEvent.Remove) &&
        !excludedPropertyNames.includes(x.propertyName)) {
      isUpdated = true
    }
  })
  return isUpdated
}

const goLicenseKey = '73f946e5b56428a800ca0d2b113f69ed1bb37e3a9ed61ff45e5741f7ee0d681d2bcbe92d58da8fc1d4ac5cec1c7b90d1dcc0392fc31c0732e562dad446e18ef1b76475e2145841daa60675c49dff7df2fe7177f5cbe77ff1df2adca6efa8d18c5abda3d248985eba3b680530557eb04fa8f8d1'

export { createDiagram, addNewNodeAndStartEdit, createGroup, calculatePosition, toggleIsIncludedInQuery, sortAZ, shouldUpdate, goLicenseKey }



// WEBPACK FOOTER //
// ./src/graph_parts/tds_diagram.js